import "@/App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";

import Home from "@/pages/Home";
import MatchMyLook from "@/pages/MatchMyLook";
import Results from "@/pages/Results";
import DontMessUp from "@/pages/DontMessUp";
import SavedLooks from "@/pages/SavedLooks";
import Wardrobe from "@/pages/Wardrobe";
import StyleMe from "@/pages/StyleMe";
import OutfitCheck from "@/pages/OutfitCheck";
import MoireLook from "@/pages/MoireLook";
import SharedLook from "@/pages/SharedLook";
import HomeLanding from "@/pages/HomeLanding";
import HomeStylePiece from "@/pages/HomeStylePiece";
import RoomCheck from "@/pages/RoomCheck";
import MyHome from "@/pages/MyHome";
import About from "@/pages/About";
import Profile from "@/pages/Profile";
import { SignIn, SignUp, ForgotPassword, ResetPassword } from "@/pages/Auth";
import { Privacy, Terms } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

// large image-led editorial route — code-split so it never weighs the core bundle
const CollectionKCCinem0031 = lazy(() => import("@/pages/CollectionKCCinem0031"));

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Seo />
        <Layout>
          <Suspense fallback={<div className="min-h-screen bg-[#0D0D0D]" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/match" element={<MatchMyLook />} />
            <Route path="/results" element={<Results />} />
            <Route path="/dont-mess-up" element={<DontMessUp />} />
            <Route path="/saved" element={<SavedLooks />} />
            <Route path="/wardrobe" element={<Wardrobe />} />
            <Route path="/style-me" element={<StyleMe />} />
            <Route path="/outfit-check" element={<OutfitCheck />} />
            <Route path="/look" element={<MoireLook />} />
            <Route path="/look/shared/:id" element={<SharedLook />} />
            <Route path="/home" element={<HomeLanding />} />
            <Route path="/home/style-piece" element={<HomeStylePiece />} />
            <Route path="/home/room" element={<RoomCheck />} />
            <Route path="/home/my-home" element={<MyHome />} />
            <Route path="/about" element={<About />} />
            <Route path="/collections/kc-cinem-003-1" element={<CollectionKCCinem0031 />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Suspense>
        </Layout>
        <Toaster position="top-center" theme="dark" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
